import { motion } from "framer-motion";
import { INCONTRI } from "@/lib/site";

const Incontri = () => (
  <section id="incontri" className="relative overflow-hidden bg-[#0C1B33] py-20 text-[#FAF8F5] sm:py-28" data-testid="incontri-section">
    <div
      aria-hidden
      className="absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full opacity-40 blur-3xl"
      style={{ background: "radial-gradient(circle, rgba(20,184,166,0.25), transparent 65%)" }}
    />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-16 max-w-2xl"
      >
        <p className="mb-3 text-xs font-bold uppercase tracking-[0.22em] text-[#14B8A6]">03 — Il programma</p>
        <h2 className="font-display text-3xl font-semibold tracking-tight sm:text-5xl">
          Sei incontri, sei isole da esplorare
        </h2>
        <p className="mt-4 text-base leading-relaxed text-[#FAF8F5]/70 sm:text-lg">
          Un capitolo al mese: informazione solida, strumenti pratici e spazio per la propria
          esperienza. Lo stesso programma vale per il gruppo e per il percorso individuale.
        </p>
      </motion.div>

      <div>
        {INCONTRI.map((item, idx) => (
          <motion.article
            key={item.num}
            data-testid={`incontro-${item.num}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: 0.05 }}
            className="group grid grid-cols-1 gap-4 border-t border-[#FAF8F5]/12 py-10 transition-colors duration-500 hover:bg-[#FAF8F5]/[0.03] md:grid-cols-12 md:gap-8 md:py-12"
          >
            <div className="md:col-span-2">
              <span className="font-display text-6xl font-semibold leading-none text-transparent transition-all duration-500 sm:text-7xl" style={{ WebkitTextStroke: "1.5px rgba(20,184,166,0.55)" }}>
                {item.num}
              </span>
            </div>
            <div className="md:col-span-4">
              <h3 className="font-display text-2xl font-semibold leading-snug sm:text-3xl">
                {item.title}
              </h3>
            </div>
            <div className="md:col-span-6">
              <p className="text-sm leading-relaxed text-[#FAF8F5]/75 sm:text-base">{item.desc}</p>
            </div>
          </motion.article>
        ))}
      </div>

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="mt-10 border-t border-[#FAF8F5]/12 pt-8 text-sm italic text-[#FAF8F5]/60"
        data-testid="incontri-note-individuale"
      >
        Nel percorso individuale si inizia con la psicoeducazione su questi sei temi; al termine,
        sarai tu a decidere se concludere qui o prolungare il viaggio.
      </motion.p>
    </div>
  </section>
);

export default Incontri;
